import { Route, Routes, useLocation } from "react-router-dom";
import AuthPage from "../pages/AuthPage";
import AppPage from "../pages/AppPage";
import { useEffect } from "react";
import LoginPage from "../pages/auth/LoginPage";
import AddCasePage from "../pages/app/AddCasePage";
import AddClipPage from "../pages/app/audioUpload/AddClipPage";
import CasesPage from "../pages/app/CasesPage";
import ClipsPage from "../pages/app/ClipsPage";
import EditorPage from "../pages/app/EditorPage";
import AudioDawEditorPage from "../pages/app/AudioDawEditorPage";
import { EditUserPage } from "../pages/app/admin/EditUserPage";
import { AddUserPage } from "../pages/app/admin/AddUserPage";
import ListUsersPage from "../pages/app/admin/ListUsersPage";
import { ProtectedRoute } from "./ProtectedRoute";
import AudioUploadNormalizationPage from "../pages/app/audioUpload/AudioUploadNormalizationPage";
import FilterRunningPage from "../pages/app/filter/FilterRunningPage";
import GlimpseSelectFilesPage from "../pages/app/glimpse/GlimpseSelectFilesPage";
import GlimpsePropertiesPage from "../pages/app/glimpse/GlimpsePropertiesPage";
import GlimpseRunningPage from "../pages/app/glimpse/GlimpseRunningPage";
import FilteredFilesPage from "../pages/app/filter/FilteredFilesPage";
import ExportPage from "../pages/app/ExportPage";
import NoiseFilterRunningPage from "../pages/app/filter/NoiseFilterRunningPage";
import AlignPage from "../pages/app/AlignPage";
import { useDispatch } from "react-redux";
import { fullCaseReset } from "../App";
import { AdminProtectedRoute } from "./AdminProtectedRoute";
import { LicensePage } from "../pages/app/admin/LicensePage";
import { LicenseErrorPage } from "../pages/app/admin/LicenseErrorPage";
// import HistoryPage from "../pages/app/HistoryPage";
import { UploadErrorPage } from "../pages/app/UploadErrorPage";
import { GlimpseErrorPage } from "../pages/app/glimpse/GlimpseErrorPage";
import AudioUploadPage from "../pages/app/audioUpload/AudioUploadPage";
import SyncResultsPage from "../pages/app/sync/SyncResultsPage";
import ClipNavigator from "../pages/app/ClipNavigator";
import { useAuth } from "../store/auth/hooks";
import { useUsers } from "../store/users/hooks";
import { useFeature } from "flagged";
import { AUDIODAW_EDITOR } from "../FeatureFlags";

export default function AppRoutes() {
  const loc = useLocation();
  const dispatch = useDispatch();
  const { logout } = useAuth();
  const { reset: usersReset } = useUsers();
  const useAudiodawEditor = useFeature(AUDIODAW_EDITOR);

  const reloadPage = (loc) => {
    console.log("RELOADING PAGE: ", loc); // refresh
  };

  useEffect(() => {
    //Implementing the setInterval method
    if (loc && loc.pathname.indexOf("login") > 0) {
      console.log("FULL SITE RESET");
      logout();
      usersReset();
      fullCaseReset(dispatch);
    }

    const interval = setInterval(() => {
      if (loc && loc.pathname) {
        if (
          loc.pathname.indexOf("normalizing") > 0 ||
          loc.pathname.indexOf("filtering") > 0 ||
          loc.pathname.indexOf("running") > 0
        ) {
          reloadPage(loc);
        }
      }
    }, 15000);

    //Clearing the interval
    return () => clearInterval(interval);
  }, [logout, dispatch, loc, usersReset]);

  return (
    <Routes>
      <Route path="/" element={<AuthPage />}>
        <Route path="/login" element={<LoginPage />} />
      </Route>
      <Route path="/app" element={<AppPage />}>
        <Route
          path="/app/cases"
          element={
            <ProtectedRoute>
              <CasesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/app/cases/:caseId/clips"
          element={
            <ProtectedRoute>
              <ClipsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/app/cases/:caseId/addClip"
          element={
            <ProtectedRoute>
              <AddClipPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/app/cases/:caseId/clips/:clipId/addFiles"
          element={
            <ProtectedRoute>
              <AddClipPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/app/cases/:caseId/clips/:clipId/import"
          element={
            <ProtectedRoute>
              <AudioUploadPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/app/addCase"
          element={
            <ProtectedRoute>
              <AddCasePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/app/cases/:caseId/clips/:clipId"
          element={
            <ProtectedRoute>
              <ClipNavigator />
            </ProtectedRoute>
          }
        />
        <Route
          path="/app/cases/:caseId/clips/:clipId/editor"
          element={
            <ProtectedRoute>
              {useAudiodawEditor ? (
                <AudioDawEditorPage />
              ) : (
                <EditorPage mode="editor" />
              )}
            </ProtectedRoute>
          }
        />
        {/* <Route
          path="/app/cases/:caseId/clips/:clipId/history"
          element={
            <ProtectedRoute>
              <HistoryPage />
            </ProtectedRoute>
          }
        /> */}
        <Route
          path="/app/cases/:caseId/clips/:clipId/normalizing"
          element={
            <ProtectedRoute>
              <AudioUploadNormalizationPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/app/cases/:caseId/clips/:clipId/filtering"
          element={
            <ProtectedRoute>
              <FilterRunningPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/app/cases/:caseId/clips/:clipId/uploadError"
          element={
            <ProtectedRoute>
              <UploadErrorPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/app/cases/:caseId/clips/:clipId/glimpse/selectFiles"
          element={
            <ProtectedRoute>
              <GlimpseSelectFilesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/app/cases/:caseId/clips/:clipId/glimpse/properties"
          element={
            <ProtectedRoute>
              <GlimpsePropertiesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/app/cases/:caseId/clips/:clipId/glimpse/running"
          element={
            <ProtectedRoute>
              <GlimpseRunningPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/app/cases/:caseId/clips/:clipId/filtered/output"
          element={
            <ProtectedRoute>
              <FilteredFilesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/app/cases/:caseId/clips/:clipId/glimpse/error"
          element={
            <ProtectedRoute>
              <GlimpseErrorPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/app/cases/:caseId/clips/:clipId/sync"
          element={
            <ProtectedRoute>{<EditorPage mode="sync" />}</ProtectedRoute>
          }
        />
        <Route
          path="/app/cases/:caseId/clips/:clipId/syncResults"
          element={
            <ProtectedRoute>
              <SyncResultsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/app/cases/:caseId/clips/:clipId/noiseFiltering"
          element={
            <ProtectedRoute>
              <EditorPage mode="sng" />
            </ProtectedRoute>
          }
        />
        <Route
          path="/app/cases/:caseId/clips/:clipId/noiseFiltering/running"
          element={
            <ProtectedRoute>
              <NoiseFilterRunningPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/app/cases/:caseId/clips/:clipId/export"
          element={
            <ProtectedRoute>
              <ExportPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/app/cases/:caseId/clips/:clipId/align"
          element={
            <ProtectedRoute>
              <AlignPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/app/admin/license"
          element={
            <AdminProtectedRoute>
              <LicensePage />
            </AdminProtectedRoute>
          }
        />
        <Route
          path="/app/admin/users"
          element={
            <AdminProtectedRoute>
              <ListUsersPage />
            </AdminProtectedRoute>
          }
        />
        <Route
          path="/app/admin/addUser"
          element={
            <AdminProtectedRoute>
              <AddUserPage />
            </AdminProtectedRoute>
          }
        />
        <Route
          path="/app/admin/user/:userId"
          element={
            <AdminProtectedRoute>
              <EditUserPage />
            </AdminProtectedRoute>
          }
        />
        {/*This is NOT a protected route*/}
        <Route path="/app/licenseError" element={<LicenseErrorPage />} />
      </Route>
    </Routes>
  );
}
